export function formatAsRegionalPhoneCode(value) {
    if (!value)
        return;
    if (value.startsWith('+55')) {
        return `+${value.replace(/[^\d]/g, '')}`;
    }
    return `+55${value.replace(/[^\d]/g, '')}`;
}
export function formatAsPhoneNumber(value) {
    if (!value)
        return '';
    return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{4})\d+$/, '$1');
}
export function formatPhoneOnlyLastFourDigits(value) {
    if (!value)
        return;
    return `(XX) XXXXX-${value.replace(/\D/g, '').slice(-4)}`;
}
